import {IDLE} from "../../common/statuses";

export const initialState = {
    getGroups: {
        data: undefined,
        status: IDLE,
    },
    getLog: {
        data: undefined,
        status: IDLE,
    },
    selected: {
        data: undefined,
        status: IDLE,
    },
    getHomework: {
        data: undefined,
        status: IDLE,
    },
    getHomeworks: {
        data: undefined,
        status: IDLE,
    },
    save: {
        errors: undefined,
        status: IDLE,
    },
    saveVisits: {
        message: undefined,
        status: IDLE,
    },
    saveStudent: {
        errors: undefined,
        status: IDLE,
    },
    saveHW: {
        message: undefined,
        status: IDLE,
    },
    delete: {
        errors: undefined,
        status: IDLE,
    },
    changeState: {
        errors: undefined,
        status: IDLE,
    },
    transferStudent: {
        message: undefined,
        status: IDLE,
    },
    deleteStudentFromGroup: {
        message: undefined,
        status: IDLE,
    },
}